import { useEffect, useRef, useState } from "react";

export default function CountUp({ value = 0, prefix = "$", decimals = 2, duration = 900, className }) {
  const [v, setV] = useState(0);
  const raf = useRef();
  useEffect(() => {
    const startT = performance.now();
    const tick = (now) => {
      const p = Math.min(1, (now - startT) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setV(value * eased);
      if (p < 1) raf.current = requestAnimationFrame(tick);
    };
    raf.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf.current);
  }, [value, duration]);
  return (
    <span className={className}>
      {prefix}{v.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}
    </span>
  );
}
